import vueCustomerSvc from '../../services/vueCustomerSvc';
import Vue from 'vue';
Vue.use(require('vue-moment'));

const memberProductTypes = ["color_kit", "light_works", "root_reboot"];

export const state = {
  info: {},
  cdata: {},
  marketingPreferences: {},
  customerEditForm: {},
  recentInvoices: [],
  loadingRecentInvoices: false
};

export const getters = {
  disableBirthday(state) {
    return Boolean(state.info.birthday_month && state.info.birthday_day);
  },

  boxesUsed(state) {
    let boxes = [];

    memberProductTypes.forEach(type => {
      if (state.cdata.purchaseSummaryByType && state.cdata.purchaseSummaryByType[type]) {
        boxes.push(state.cdata.purchaseSummaryByType[type].numPurchasedTotal);
      }
    });

    return boxes.reduce((sum, a) => sum + a, 0);
  },

  memberSince(state) {
    let firstPurchaseDates = [];
    memberProductTypes.forEach(type => {
      if (state.cdata.purchaseSummaryByType && state.cdata.purchaseSummaryByType[type]) {
        firstPurchaseDates.push(state.cdata.purchaseSummaryByType[type].firstPurchaseDate);
      }
    });

    return firstPurchaseDates.sort((a, b) => new Date(a) - new Date(b))[0];
  },

  isColorSubscriber(state) {
    let colorSubscriber = false;
    memberProductTypes.forEach(type => {
      if (state.cdata.activeSubTypes && state.cdata.activeSubTypes[type]) {
        colorSubscriber = true;
      }
    });

    return colorSubscriber;
  },

  subscribeAndSaveProduct(state) {
    let product = null;

    if (state.cdata.lastOneTimeColor && state.cdata.lastOneTimeColor.product_id) {
      product = state.cdata.lastOneTimeColor;
    } else if (state.cdata.lastRenewableProduct && state.cdata.lastRenewableProduct.product_id) {
      product = state.cdata.lastRenewableProduct;
    }

    return product;
  },

  onTheWaySubsMap(state) {
    let map = {};

    state.recentInvoices.forEach(invoice => {
      invoice.items.forEach(item => {
        if (item.subscription_id && (invoice.order_status == 'pending' || invoice.order_status == 'processing' || invoice.order_status == 'shipped')) {
          map[item.subscription_id] = {
            status: invoice.order_status,
            trackingUrl: invoice.tracking_url
          };
        }
      });
    });

    return map;
  },

  colorSatisfactionInvoice(state) {
    let invoice;
    //- check if this type of invoice exists
    if (state.cdata.lastDeliveredColorInvoice && state.cdata.lastDeliveredColorInvoice.id) {
      invoice = state.cdata.lastDeliveredColorInvoice;
    } else {
      return {};
    }

    //- proceed only if colorSatisfaction has not been answered
    if (state.cdata.hasOwnProperty("colorSatisfactionScore") && state.cdata.colorSatisfactionScore > -1) {
      return {};
    }

    //- proceed only if this is their first color_kit order
    if (state.cdata.purchaseSummaryByType.color_kit.numPurchasedTotal > 1) {
      return {};
    }

    //- check if it has been 8 days since the delivery
    if (Vue.moment().diff(Vue.moment(invoice.dateDelivered), 'days') < 8) {
      return {};
    }

    //- check if it is more than 10 days before the next renewal order
    if (state.cdata.nextRefillDate && Vue.moment(state.cdata.nextRefillDate).diff(Vue.moment(), 'days') < 10) {
      return {};
    }

    return invoice;
  },

  productIdInPurchaseList: (state) => (id) => {
    return (state.cdata.purchasedProductIds || []).indexOf(id) >= 0;
  },

  visitorType(state) {
    if (!state.cdata.visitorType) {
      return '';
    }

    return state.cdata.visitorType.toLowerCase();
  },

  hasMembershipPricing: (state) => {
    return ['expanded_membership', 'expanded_membership_and_prices'].includes(state.cdata.priceGroup);
  },
};

export const actions = {
  loadCustomer({ commit, dispatch }) {
    vueCustomerSvc.loadCustomer()
      .then(res => {
        commit('setCustomerInfo', res.data);
        commit('setCustomerEditForm', res.data);
        dispatch('normalizeMarketingPreferences', res.data.marketingPreferences);
      });
  },

  refreshCustomerCdata({ commit }) {
    vueCustomerSvc.getCustomerCdata().then(res => commit('setCdata', res.data));
  },

  updateCustomer({ dispatch, state }) {
    vueCustomerSvc.updateCustomer(state.customerEditForm)
      .then(res => {
        if (res.validation && Array.isArray(res.validation)) {
          res.validation.forEach(err => {
            var errMsg = err;
            if (err == 'invalid date') {
              errMsg = 'Birthday date is invalid. Please update and try again.';
            }
            dispatch('notifyError', errMsg, { root: true });
          });
          return;
        }

        dispatch('notifySuccess', 'Your account has been updated.', { root: true });

        if (res.sendSMSOptIn) {
          dispatch('notifyInfo', "You've opted-in to receive SMS messages. Check your phone to complete the process");
        }

        dispatch('loadCustomer');
      })
      .catch(err => {
        // this.$root.checkUserLoginError(err);

        var error = 'We were not able to update your info. Please try again or contact Color Crew';
        if (err.data && err.data.message) {
          error = err.data.message;
        }

        dispatch('notifyError', error, { root: true });
      });
  },

  updateEmailPreferences({ dispatch, state }) {
    var unsubMessages = [];

    state.marketingPreferences.allMessageTypes.forEach(key => {
      if (!state.marketingPreferences[key]) {
        unsubMessages.push(key);
      }
    });

    var payload = {
      email: state.info.email,
      marketingPreferences: {
        unsubMessages
      }
    };

    dispatch('setMarketingPreferences', payload);
  },

  unsubAllEmails({ dispatch, state }, value) {
    //- when value is false, do not update, let user select to what they
    //- want to subscribe to
    if (!value || state.marketingPreferences.unsub == value) {
      return;
    }

    var payload = {
      email: state.info.email,
      marketingPreferences: {
        unsub: true
      }
    };

    dispatch('setMarketingPreferences', payload);
  },

  setMarketingPreferences({ dispatch }, payload) {
    vueCustomerSvc.setMarketingPreferences(payload)
      .then(() => {
        dispatch('getMarketingPreferences');
        dispatch('notifySuccess', 'Your marketing preferences have been updated.', { root: true });
      })
      .catch(() => {
        dispatch('notifyError', null, { root: true });
      });
  },

  updateSmsPreferences({ commit, dispatch, state }, val) {
    commit('setSmsOptInOut', val);

    if (state.info.id && !state.info.phone_mobile) {
      vueCustomerSvc.updateCustomer({ phone_mobile: state.info.marketingPreferences.mobile_number })
        .then(() => {
          dispatch('callSMSOptInOut');
        });
    } else {
      dispatch('callSMSOptInOut');
    }

  },

  callSMSOptInOut({ dispatch, state }) {
    var payload = {
      email: state.info.email,
      mobileNumber: state.marketingPreferences.mobile_number,
      optInSms: !state.marketingPreferences.sms_opt_out
    };

    vueCustomerSvc.smsOptInOut(payload)
      .then(() => {
        var message = `You have ${state.marketingPreferences.sms_opt_out ? 'unsubscribed' : 'subscribed'} to order updates & reminders via SMS.`;
        if (!state.marketingPreferences.sms_opt_out) {
          message += ' Check your phone to complete the process.';
        }

        dispatch('notifySuccess', message, { root: true });
      })
      .catch(() => {
        dispatch('notifyError', 'We were not able to update your SMS preferences', { root: true });
      });
  },

  getMarketingPreferences({ dispatch }) {
    vueCustomerSvc.getMarketingPreferences()
      .then(res => {
        dispatch('normalizeMarketingPreferences', res.data);
      });
    //- ignoring error
  },

  getRecentInvoices({ state, commit }) {
    if (state.loadingRecentInvoices) {
      return;
    }

    commit('setLoadingRecentInvoices', true);
    return new Promise((resolve, reject) => {
      vueCustomerSvc.getCustomerRecentInvoices().then(res => {
        commit('setRecentInvoices', res.data);
        resolve();
      }).catch(reject).finally(() => commit('setLoadingRecentInvoices', false));
    });
  },

  normalizeMarketingPreferences({ commit }, val) {
    if (!val) {
      return;
    }
    //- need to normalize marketingPreference object for vuex consumption
    var prefs = {};

    if (val) {
      prefs.unsub = val.unsub;
      prefs.tips = val.messages.tips;
      prefs.promotions = val.messages.promotions;
      prefs.allMessageTypes = val.allMessageTypes;
      prefs.sms_opt_out = val.sms_opt_out;
      prefs.mobile_number = val.mobile_number;
    }

    commit('setMarketingPreferences', prefs);
  },

  updateBirthday({ commit, state }) {
    let birthday = null;
    if (state.customerEditForm.birthday_month && state.customerEditForm.birthday_day) {
      var month = ('0' + state.customerEditForm.birthday_month).slice(-2);
      var day = ('0' + state.customerEditForm.birthday_day).slice(-2);
      birthday = month + '/' + day + '/1896';
    }

    commit('setBirthday', birthday);
  }
};

export const mutations = {
  setCustomerInfo(state, val) {
    state.info = val;
  },

  setCustomerEditForm(state, val) {
    state.customerEditForm = Object.assign({}, val);
  },

  setMarketingPreferences(state, val) {
    state.marketingPreferences = val;
  },

  setEmailTips(state, val) {
    state.marketingPreferences.tips = val;
  },

  setEmailPromotions(state, val) {
    state.marketingPreferences.promotions = val;
  },

  setEmailUnsub(state, val) {
    state.marketingPreferences.unsub = val;
  },

  setFirstName(state, val) {
    state.customerEditForm.first_name = val;
  },

  setLastName(state, val) {
    state.customerEditForm.last_name = val;
  },

  setEmail(state, val) {
    state.customerEditForm.email = val;
  },

  setPhoneMain(state, val) {
    state.customerEditForm.phone_main = val;
  },

  setPhoneMobile(state, val) {
    state.customerEditForm.phone_mobile = val;
  },

  setBirthday(state, val) {
    state.customerEditForm.birthday = val;
  },

  setBirthdayDay(state, val) {
    state.customerEditForm.birthday_day = val;
  },

  setBirthdayMonth(state, val) {
    state.customerEditForm.birthday_month = val;
  },

  setSmsOptInOut(state, val) {
    state.marketingPreferences.sms_opt_out = val;
  },

  setCdata(state, val) {
    state.cdata = val;
  },

  setRecentInvoices(state, val) {
    state.recentInvoices = val;
  },

  setLoadingRecentInvoices(state, val) {
    state.loadingRecentInvoices = Boolean(val);
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
